import { toMerchantPaymentPlan } from '@src/data/mappers/promoPlanMappers'
import { PromoPlan } from '@src/data/types/PromoPlan'
import FormattedMerchantPaymentPlan from './FormattedMerchantPaymentPlan'

interface Props {
  resolvedPlan: PromoPlan
}

const FormattedResolvedApplicablePlan = ({ resolvedPlan }: Props) =>
  resolvedPlan.termRates.length === 1 ? (
    <FormattedMerchantPaymentPlan merchantPaymentPlan={toMerchantPaymentPlan(resolvedPlan)} />
  ) : (
    <span>{resolvedPlan.label}</span>
  )

export default FormattedResolvedApplicablePlan
